<template>
  <Searchbox @search="redditSearch" />
</template>

<script>
import Searchbox from "../components/Searchbox";
export default {
  name: "Home",
  components: {
    Searchbox,
  },
  methods: {
    redditSearch(searchInput, sort, limit) {
      this.$router.push({
        name: "Search",
        params: { term: searchInput, sort, limit },
      });

    },
  },
};
</script>
